import React from 'react';
import { Grid2 as Grid, Link } from '@mui/material';
import { IControlLink } from '../../shared.interfaces';
import { customPalette } from '../../../styles/palette';
import { useNavigate } from 'react-router-dom';

export const ControlPad = (props: IControlLink) => {
  const navigate = useNavigate();
  return (
    <Grid sx={{ display: 'flex', flexDirection: 'row' }}>
      <Link
        onClick={() => {
          navigate(props.toLink);
        }}
        className={`${props.showIcon ? '' : 'hide'}`}
        style={{
          textDecoration: 'none',
          marginTop: '1.875rem',
          padding: '0.625rem',
          borderRadius: '100px',
          background: 'white',
          border: '0.125rem',
          borderColor: customPalette.lightBlue,
          borderStyle: 'solid',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img src={props.imgSrc} alt={props.altVal} />
      </Link>
    </Grid>
  );
};
